import React from 'react';

export default ({ presenter, fileId }: { presenter?: any; fileId?: any }) =>
  fileId || presenter ? (
    <div className="presenting-info">
      {fileId ? <div>{fileId}</div> : null}
      {presenter ? <div>{presenter}</div> : null}
    </div>
  ) : null;
